import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";
import "./RowButton.css";

/**
 * A clickable row, card, tile or dropdown trigger: any click target that is
 * not a pill button. It only resets the browser button look and adds the
 * shared focus ring and disabled state; the layout and look stay with the
 * caller's own class.
 * Example: <RowButton className="search-row" onClick={open}>…</RowButton>
 */
const RowButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ type = "button", className = "", ...rest }, ref) => (
  <button
    ref={ref}
    type={type}
    className={`ds-row-btn ${className}`.trim()}
    {...rest}
  />
));

RowButton.displayName = "RowButton";

export default RowButton;
